export function isNullOrEmpty(value: string | null | undefined): boolean {
  return value == null || value.length === 0;
}

export function isNullOrWhitespace(value: string | null | undefined): boolean {
  return isNullOrEmpty(value) || value?.trim().length === 0;
}
